import prodClient from 'client/prod';
import messages from 'messages/ja.ton.json';

prodClient(messages);
